module.exports = __webpack_public_path__ + "img/Curve.f6f7c977.svg";